document.addEventListener("DOMContentLoaded", function() {
    // Scroll to element
    const scrollToLinks = document.querySelectorAll(".scroll-to");
    scrollToLinks.forEach(link => {
        link.addEventListener("click", function(event) {
            event.preventDefault();
            const element = document.querySelector(this.getAttribute('href'));
            const offsetTop = element.offsetTop - 15;
            window.scrollTo({
                top: offsetTop,
                behavior: "smooth"
            });
        });
    });

    // Mobile navigation
    if (window.innerWidth < 992) {
        const navbarToggler = document.querySelector(".navbar-toggler");
        navbarToggler.addEventListener("click", function() {
            const navbarExpand = document.querySelector(".navbar-expand-lg");
            if (!navbarToggler.classList.contains('collapsed')) {
                navbarExpand.style.position = 'absolute';
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            } else {
                navbarExpand.style.position = 'fixed';
            }
        });

        // Handle level 1 click
        const level1Links = document.querySelectorAll(".navbar-nav .nav-link.level-1");
        level1Links.forEach(link => {
            link.addEventListener("click", function(event) {
                const parent = this.parentElement;
                if (!parent.classList.contains('open') && parent.classList.contains('dropdown')) {
                    if (!this.classList.contains('search')) {
                        event.preventDefault();
                        parent.querySelector('.dropdown-menu.level-2').classList.add('show');
                        document.querySelectorAll('.navbar-nav .nav-item.level-1').forEach(item => item.classList.add('hidden'));
                        this.classList.add('open');
                        parent.classList.add('open');
                        parent.classList.remove('hidden');
                        document.querySelector('.nav-back').classList.add('level2');
                    }
                }
            });
        });

        // Handle level 2 click
        const level2Links = document.querySelectorAll(".navbar-nav .nav-link.level-2");
        level2Links.forEach(link => {
            link.addEventListener("click", function(event) {
                const parent = this.parentElement;
                if (!parent.classList.contains('open') && parent.classList.contains('dropdown')) {
                    event.preventDefault();
                    parent.querySelector('.dropdown-menu.level-3').classList.add('show');
                    document.querySelectorAll('.navbar-nav .nav-link.level-1').forEach(item => item.classList.add('hidden'));
                    document.querySelectorAll('.navbar-nav .nav-item.level-2').forEach(item => item.classList.add('hidden'));
                    this.classList.add('open');
                    parent.classList.add('open');
                    parent.classList.remove('hidden');
                    const navBack = document.querySelector('.nav-back');
                    navBack.classList.remove('level2');
                    navBack.classList.add('level3');
                }
            });
        });

        // Handle nav-back click
        const navBack = document.querySelector(".nav-back");
        navBack.addEventListener("click", function(event) {
            if (navBack.classList.contains('level3')) {
                document.querySelector('.dropdown-menu.level-3').classList.remove('show');
                document.querySelectorAll('.navbar-nav .nav-item.level-2').forEach(item => item.classList.remove('hidden'));
                document.querySelectorAll('.navbar-nav .nav-item.level-2').forEach(item => item.classList.remove('open'));
                document.querySelectorAll('.navbar-nav .nav-link.level-2').forEach(item => item.classList.remove('open'));
                document.querySelector('.navbar-nav .nav-item.level-1.open .nav-link.open').classList.remove('hidden');
                navBack.classList.remove('level3');
                navBack.classList.add('level2');
            } else {
                if (navBack.classList.contains('level2')) {
                    document.querySelectorAll('.navbar-nav .level-1').forEach(item => item.classList.remove('open'));
                    document.querySelectorAll('.navbar-nav .level-1').forEach(item => item.classList.remove('hidden'));
                    document.querySelectorAll('.navbar-nav .level-2').forEach(item => item.classList.remove('show'));
                    navBack.classList.remove('level2');
                }
            }
        });
    } else {
        // Hover effect on larger screens
        const level1HoverLinks = document.querySelectorAll(".navbar-nav .nav-link.level-1");
        level1HoverLinks.forEach(link => {
            link.addEventListener("mouseenter", function() {
                const parent = this.parentElement;
                if (!parent.classList.contains('open')) {
                    document.querySelectorAll(".navbar-nav .nav-item.level-1").forEach(item => item.classList.remove('open'));
                }
            });
        });

        level1Links.forEach(link => {
            link.addEventListener("click", function(event) {
                const parent = this.parentElement;
                if (this.classList.contains('dropdown') && !parent.classList.contains('open')) {
                    if (!this.classList.contains('search')) {
                        event.preventDefault();
                        parent.classList.add('open');
                    }
                }
            });
        });
    }

    // Accordion functionality
    const accordionHeadlines = document.querySelectorAll(".accordion .headline");
    accordionHeadlines.forEach(headline => {
        headline.addEventListener("click", function() {
            if (this.classList.contains('image-2')) {
                if (this.classList.contains('open')) {
                    this.classList.remove('open');
                    this.parentElement.parentElement.querySelector('.more').classList.remove('open');
                } else {
                    this.classList.add('open');
                    this.parentElement.parentElement.querySelector('.more').classList.add('open');
                }
            } else {
                if (this.classList.contains('open')) {
                    document.querySelectorAll(".accordion .more").forEach(more => more.style.display = 'none');
                    this.classList.remove('open');
                } else {
                    document.querySelectorAll(".accordion .more").forEach(more => more.style.display = 'none');
                    document.querySelectorAll(".accordion .headline").forEach(h => h.classList.remove('open'));
                    this.parentElement.parentElement.querySelector('.more').style.display = 'block';
                    this.classList.add('open');
                }
            }
        });
    });

    const showAllBtn = document.querySelector(".accordion .show-all");
    if (showAllBtn) {
        showAllBtn.addEventListener("click", function(event) {
            event.preventDefault();
            this.parentElement.parentElement.querySelector('.headline').classList.add('open');
            this.parentElement.querySelector('.more').style.maxHeight = '2000px';
            this.style.display = 'none';
        });
    }
});